import { GET_STATION_BY_CITY } from '../actions/chargingStation';

const initialState = {
  isLoading: false,
  stationByCities: [],
  page: 1,
  limit: 10,
  total: 0,
  totalPages: 0,
};

const stationByCityReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_STATION_BY_CITY.REQUEST: {
      return { ...state, isLoading: true };
    }

    case GET_STATION_BY_CITY.SUCCESS: {
      const isPaginated = payload && payload.results;
      const newData = isPaginated ? payload.results : payload;
      const page = isPaginated ? payload.page : 1;
      const total = isPaginated ? payload.totalResults : newData.length;
      const totalPages = isPaginated ? payload.totalPages : 1;
      const limit = isPaginated ? payload.limit : newData.length;

      return {
        ...state,
        isLoading: false,
        stationByCities: page > 1 ? [...state.stationByCities, ...newData] : newData,
        page,
        total,
        totalPages,
        limit,
      };
    }

    case GET_STATION_BY_CITY.FAIL: {
      return { ...state, isLoading: false };
    }

    default:
      return { ...state };
  }
};
export default stationByCityReducer;
